<template>
    <div class="appdetail">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-buttons">
                        <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn">
                            <font>保存</font>
                        </el-button>
                    </div>
                </div>
            </div>
            <el-tabs class="appdetail-content" type="border-card" v-model="currentDetailTabsModel" @tab-click="tabClick">
                <el-tab-pane label="列表" name="列表">
                </el-tab-pane>
                <el-tab-pane label="详情" name="详情">
                    <div class="appdetail-content" :style="{height: 'calc(100vh - 205px)'}">
                        <el-form :model="dataInfo" ref="form" class="demo-user">
                            <el-collapse v-model="activeNames">
                                <el-collapse-item title="基本信息" name="1">
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item prop="pName" label="所属上级" label-width="120px">
                                                <el-input disabled size="small" v-model="dataInfo.pName">
                                                    <i slot="suffix" class="el-icon-circle-close input-suffix-icon" @click="clearInput(dataInfo,chooseParam)" v-show="dataInfo.app != ''"></i>
                                                    <el-button size="small" slot="append" icon="el-icon-search" @click="dialogVisible2 = true"></el-button>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item :rules="[{ required: true, message: '必填填写', trigger: 'blur' }]" prop="name" label="菜单名称" label-width="120px">
                                                <el-input size="small" v-model="dataInfo.name" placeholder="请输入"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="app" label="关联应用" label-width="120px">
                                                <el-input disabled size="small" v-model="dataInfo.app">
                                                    <i slot="suffix" class="el-icon-circle-close input-suffix-icon" @click="clearInput(dataInfo,chooseParam)" v-show="dataInfo.app != ''"></i>
                                                    <el-button size="small" slot="append" icon="el-icon-search" @click="choose(dataInfo,chooseParam)"></el-button>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="url" label="链接地址" label-width="120px">
                                                <el-input size="small" v-model="dataInfo.url" placeholder="请输入"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item :rules="[{ required: true, message: '必填填写', trigger: 'blur' }]" prop="sort" label="排序" label-width="120px">
                                                <el-input size="small" v-model="dataInfo.sort" placeholder="请输入"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    <el-col :span="12">
                                        <el-form-item :rules="[{ required: true, message: '必填填写', trigger: 'blur' }]" prop="sort" label="code值" label-width="120px">
                                        <el-input size="small" v-model="dataInfo.code" placeholmeder="请输入"></el-input>
                                        </el-form-item>
                                    </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="css" label="菜单图标" label-width="120px">
                                                <el-input size="small" disabled v-model="dataInfo.css">
                                                    <i :class="dataInfo.css" slot="prepend"></i>
                                                    <el-button size="small" slot="append" icon="el-icon-search" @click="dialogVisible = true"></el-button>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="reportname" label="报表文件" label-width="120px">
                                                <el-input disabled size="small" v-model="dataInfo.reportname">
                                                    <i slot="suffix" class="el-icon-circle-close input-suffix-icon" @click="clearInput(dataInfo,filechooseParam)" v-show="dataInfo.reportname != ''"></i>
                                                    <el-button size="small" slot="append" icon="el-icon-search" @click="choose(dataInfo,filechooseParam)"></el-button>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        
                                        <el-col :span="12">
                                            <el-form-item prop="path" label="外部链接" label-width="120px">
                                                <el-input size="small" v-model="dataInfo.path" placeholder="请输入"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        <el-col :span="14">

                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="hidden" label="是否隐藏？" label-width="120px">
                                                <el-switch v-model="dataInfo.hidden" :active-value="1" :inactive-value="0" active-color="#8996f1"></el-switch>
                                            </el-form-item>
                                        </el-col>
                                    <el-col :span="12">
                                            <el-form-item prop="canauthorization" label="是否允许授权？" label-width="120px">
                                                <el-switch v-model="dataInfo.canauthorization" :active-value="'1'" :inactive-value="'0'" active-color="#8996f1"></el-switch>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="isstandard" label="标准应用？" label-width="120px">
                                                <el-switch v-model="dataInfo.isstandard" :active-value="'1'" :inactive-value="'0'" active-color="#8996f1"></el-switch>
                                            </el-form-item>
                                        </el-col>
                                    <el-col :span="12">
                                            <el-form-item prop="isforapp" label="移动端？" label-width="120px">
                                                <el-switch v-model="dataInfo.isforapp" :active-value="1" :inactive-value="0" active-color="#8996f1"></el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-form>
                    </div>
                </el-tab-pane>
            </el-tabs>
        <vchoose ref="vchoose" :chooseParam="chooseParam" @updateChoose="updateChoose"></vchoose>
        <el-dialog class="allicons" title="应用图标" :visible.sync="dialogVisible" width="80%">
            <allicons @childByValue="childByValue"></allicons>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="defineCss">确 定</el-button>
            </span>
        </el-dialog>
        <!--选择所属上级弹出框 Begin-->
        <el-dialog :modal-append-to-body="false" title="选择所属上级" :visible.sync="dialogVisible2" width="30%">
            <el-tree style="height:400px;overflow-y: auto" ref="tree" :data="resourceData" show-checkbox node-key="id" :props="resourceProps" lazy :load="loadNode">
            </el-tree>
            <div slot="footer">
            <el-button type="primary" @click="defineParentData">确 定</el-button>
            <el-button @click="dialogVisible2 = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import allicons from '@/components/commonComponents/all_icons.vue'//弹出框
import vchoose from "@/components/commonComponents/datachoose.vue";
export default {
    name:"menu_managementdetail",
    components:{vchoose,allicons},
    data(){
        return{
            currentDetailTabsModel:"详情",
            drawer:false,
            loading:false,
            activeNames:['1'],
            dataInfo:{},
            filechooseParam: {
                title: "文件",
                isMulti: false,
                searchBtn: true,
                customWidth: "60%",
                tableHeader: [
                {
                    propName: "id",
                    labelName: "报表文件ID",
                    targetAttribute: "reportid",
                    isShow: "no",
                    isSearch: "no",
                    width: "60%"
                },
                {
                    propName: "code",
                    labelName: "报表名称",
                    targetAttribute: "reportname",
                    isShow: "yes",
                    isSearch: "yes",
                    width: "60%"
                },
                {
                    propName: "file",
                    labelName: "报表文件",
                    isShow: "yes",
                    isSearch: "no",
                    width: "60%"
                },
                {
                    propName: "createtime",
                    labelName: "创建时间",
                    isShow: "yes",
                    isSearch: "no",
                    lableWidth: '180px'
                },
                {
                    propName: "updatetime",
                    labelName: "修改时间",
                    isShow: "yes",
                    isSearch: "no",
                    lableWidth: '180px'
                }
                ],
                search: [],
                url: "/api-report/report",
                method: "get"
            },
            chooseParam: {
                title: "应用",
                isMulti: false,
                searchBtn: true,
                customWidth:'70%',
                tableHeader: [
                {
                    propName: "id",
                    labelName: "应用名称id",
                    isShow: 'no',
                    targetAttribute: "appid"
                },
                {
                    propName: "name",
                    labelName: "应用名称",
                    isShow: 'yes',
                    isSearch: 'yes',
                    width: '35%',
                    targetAttribute: "app"
                },
                {
                    propName: "description",
                    labelName: "描述",
                    isSearch: 'yes',
                    width: '35%',
                    isShow: 'yes'
                },
                ],
                search: [],
                url: "/api-apps/appcfg",
                method: "get"
            },
            basic_url: Config.dev_url,//请求地址
            dialogVisible:false,
            currentCss:"",
            dialogVisible2:false,
            resourceData:[],
            resourceProps: {
                children: "children",
                label: "name"
            },
        }
    },
    methods:{
        defineParentData(){
            var checkedNodes = this.$refs.tree.getCheckedNodes()
            console.log(checkedNodes)
            this.dialogVisible2 = false;
            this.dataInfo.parentcode = checkedNodes[0].code;
            this.dataInfo.pName = checkedNodes[0].name;
            this.$refs.tree.setCheckedKeys([])
        },
        loadNode(node, resolve){
            console.log(node)
            if (node.level == 0) {
                return this.getParentData(resolve);
            }
            if (node.level > 0) {
                var url = Config.dev_url + "/api-user/menus/findTreeByMenuCode"
                var data = {
                    rolecode:this.currentuser.roleCode,
                    menucode:node.data.code,
                    selectcode:this.dataInfo.parentcode
                }
                this.$axios.post(url,data).then((res)=>{
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].hasChildren = true
                    }
                    return resolve(res.data)
                }).catch((err) => {
                });
            }
        },
        getParentData(resolve){
            var url = Config.dev_url + "/api-user/menus/firstTree"
            this.$axios.post(url,{rolecode:this.currentuser.rolecode,selectcode:this.dataInfo.parentcode}).then((res)=>{
                // this.loading = false
                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].hasChildren = true
                }
                resolve(res.data)
            }).catch((err) => {
                });
        },
        //获取创建人描述
        getcreateuserdesc() {
            if (!!this.dataInfo.createuser) {
                var url = Config.dev_url + '/api-user/users/' + this.dataInfo.createuser
                this.$axios.get(url).then((res) => {
                    this.$set(this.dataInfo, 'createuserdesc', res.data.nickname)
                }).catch((err) => {
                });
            }
        },
        //获取修改人描述
        getupdateuserdesc() {
            if (!!this.dataInfo.updateuser) {
                var url = Config.dev_url + '/api-user/users/' + this.dataInfo.updateuser
                this.$axios.get(url).then((res) => {
                    this.$set(this.dataInfo, 'updateuserdesc', res.data.nickname)
                }).catch((err) => {
                });
            }
        },
        defineCss(){
            this.dataInfo.css = this.currentCss;
            this.dialogVisible = false;
        },
        childByValue(childValue){
            console.log(childValue)
            this.currentCss = childValue
        },
        addBtn(){
            this.dataInfo = {
                parentcode:-1,
                parentId:-1,
                name:"",
                url:"",
                sort:"",
                css:"",
                hidden:0,
                canauthorization:"0",
                isforapp:0,
                isstandard:"0",
                code:""
            };
            this.currentDetailTabsModel = "详情"
        },
        clearInput(data, chooseParam) {
            for (var i = 0; i < chooseParam.tableHeader.length; i++) {
                if(!!chooseParam.tableHeader[i].targetAttribute && !!this.dataInfo[chooseParam.tableHeader[i].targetAttribute]){
                    this.dataInfo[chooseParam.tableHeader[i].targetAttribute] = ""
                }
            }
        },
        choose(target, chooseParam) {
            for (var i = 0; i < chooseParam.tableHeader.length; i++) {
                chooseParam.tableHeader[i].targetObject = target;
            }
            this.chooseParam = chooseParam;
            this.$refs.vchoose.getListData("new", this.chooseParam);
        },
        updateChoose(data) {
            this.$forceUpdate();
        },
        //tab选项卡点击
        tabClick(tab){
            if(tab.label == "列表"){
                this.$store.commit('setcurrentShowPage',1)
                this.$emit("requestData")
            }else{
                this.$store.commit('setcurrentShowPage',2)
            }
        },
        saveBtn(){
            if (this.dataInfo.parentcode == '') {//上级为空给后台传-1表示为一级菜单
                this.dataInfo.parentcode = -1;
                this.dataInfo.parentId = -1;
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    var url = Config.dev_url + '/api-user/menus/saveOrUpdate';
                    this.loading = true
                    this.$axios.post(url, this.dataInfo).then((res) => {
                        this.loading = false
                        if (res.data.code == 0) {
                            this.$message.success(res.data.msg)
                        }else{
                            this.$message.warning(res.data.msg)
                        }
                    }).catch((err) => {
                    });
                } else {
                    this.$message.warning('有必填项未填写，请填写')
                }
            })
        },
        view(item){
          console.log(item)
            this.currentDetailTabsModel = "详情"
            this.dataInfo = item
            this.getupdateuserdesc()
            this.getcreateuserdesc()
            console.log(this.dataInfo,"当前详情数据")
        },
    },
    mounted(){

    },
    computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
}
</script>

<style>

</style>
